import {Injectable} from "@angular/core";
import {UserService} from "./user.service";

@Injectable()
export class AnalyticsService {

    constructor(private userService: UserService) {

    }

    public static eventClick(message, properties: any = {}): void {
    }

}
